module.exports = __webpack_public_path__ + "img/flouci.80cf749e.png";